import { HeaderHero, SEO } from './components'
import { Row, Col, Typography } from 'antd'
import Router from 'next/router'
import { useEffect } from 'react'

const tabletImage = 'PartnerWithUsHeaderImage_1024x300.jpeg'
const desktopImage = 'PartnerWithUsHeaderImage_1440x300.jpeg'
const largeScreenImage = 'PartnerWithUsHeaderImage_1620x300.jpeg'
const xtraLargeScreenImage = 'PartnerWithUsHeaderImage_1960x300.jpeg'
const smallImage = 'PartnerWithUsHeaderImage_375x188.jpeg'
const smallImage390 = 'PartnerWithUsHeaderImage_390x188.jpeg'
const mobileImage = 'PartnerWithUsHeaderImage_428x188.jpeg'
const mobileImage768 = 'PartnerWithUsHeaderImage_768x300.jpeg'

import PartnerWithUsStyle from '../../styles/PartnerWithUs.module.css'

const { Link, Text, Title } = Typography

const AgencyApplicationResults = () => {
    // Force browser back button to /PartnerWithUs
    useEffect(() => {
        window.history.pushState(null, '', window.location.href);
        const handlePopState = () => {
            Router.push('/PartnerWithUs');
        };
        window.addEventListener('popstate', handlePopState);

        return () => {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [Router]);

    return (
        <>
            <SEO
                title={"Partner With Us | CURE Auto Insurance"}
                description={"Interested in becoming a CURE agent? Learn more about the CURE Agency Program and apply to be an appointed agent in Michigan, New Jersey, Pennsylvania, and Florida."}
                url={"/PartnerWithUs/submitted"}
            />
            <HeaderHero
                desktopImage={desktopImage}
                largeScreenImage={largeScreenImage}
                mobileImage={mobileImage}
                mobileImage768={mobileImage768}
                smallImage={smallImage}
                smallImage390={smallImage390}
                tabletImage={tabletImage}
                xtraLargeScreenImage={xtraLargeScreenImage}
                title="PARTNER WITH US"
            />
            <div className={`${PartnerWithUsStyle["partner-with-us-screen"]} ${PartnerWithUsStyle["application-result-screen-padding"]}`}>
                <Col lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xl={{ span: 24 }} xs={{ span: 24 }}>
                    <Row justify="center" align="center" gutter={32}>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ display: 'flex', flexDirection: "column", justifyContent: 'center' }}>
                            <div style={{ marginBottom: "32px" }}>
                                <Text className={`${PartnerWithUsStyle["body"]}`}>
                                    Thank you for your interest!
                                </Text>
                            </div>
                            <div>
                                <Text className={`${PartnerWithUsStyle["body"]}`}>
                                    A CURE Agency Representative will contact you within 1-2 business days.
                                </Text>
                            </div>
                        </Col>
                        <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 0 }} xs={{ span: 0 }}>
                            <img src="https://assets.cure.com/img/main-site/roundy-looking-left.png" alt="Roundy" className={`${PartnerWithUsStyle["result-roundy-image"]}`} />
                        </Col>
                    </Row>
                </Col>
            </div>
        </>
    );
}

export default AgencyApplicationResults;